import BaseModel from './BaseModel'
import { BaseCollection } from './BaseCollection'

/**
 *   Form Model
 */
class Form extends BaseModel {
    defaults() {
        return {}
    }

    resourceName() {
        return 'form'
    }
}

/**
 *   Forms Collection
 *   @extends Collection
 */
class Forms extends BaseCollection {
    resourceName() {
        return 'forms'
    }

    model() {
        return Form
    }
}

export { Form, Forms }
